import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { configURI, configURI1 } from '../../../shared/apiUrlConfig';
// import { InsuranceDoc } from '../../model/insurance.model'
// import { APP_ID_RANDOM_PROVIDER } from '@angular/core/src/application_tokens';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ParInsuranceService {
  load;
  url = environment.configURI; 
  loginId;
  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  // headers = new Headers({ 'x-access-token': localStorage.getItem('Token'), 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT' });
  // options = new RequestOptions({ headers: this.headers });

  // httpClientHeaderOptions = {
  //   headers: new HttpHeaders({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  // get agent Docs
  parinsuranceDocGet() {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    // return this.http.get(this.url + '/parinsurance/getallinsurancedocs', this.options)
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/par/insurance').catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/par/insurance').catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  // get details of agent
  insdetails(id) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    // return this.http.get(this.url + '/parinsurance/getpardocument?docid=' + id, this.options)
    return this.httpClient.get(this.url + '/par/insurance/document/' + id).catch(this.userFriendlyMsgs.errorHandler);
  }

  insurancedoctypeget() {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    // return this.http.get(this.url + '/DocumentTypes/GetDocumentTypesByCategory?Category=parinsurance', this.options)
    return this.httpClient.get(this.url + '/documents/GetDocumentTypesByCategory?Category=PARINSURANCE').catch(this.userFriendlyMsgs.errorHandler);
  }

  // create new agent info
  createNewParInsurance(data, type?) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    this.loginId = localStorage.getItem('loginID');
    const body = {
      policynum: data.policynum,
      phonenum: data.phonenum,
      contact: data.contact,
      insurancevendor: data.insurancevendor,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      postalcode: data.postalcode,
      expiration: data.expiration,
      general_liability_occurance: data.generalliabilityoccurance,
      // workmas_comp_liability_limit: data.workmascompliabilitylimit,
      eo_cyber: data.eo_cyber,
      crimefidelity: data.crimefidelity,
      auto_liability_limit: data.autoliabilitylimit,
      auto_liability_expiration: data.autoexpiration,
      garage_liability_limit: data.garageliabilitylimit,
      // cancellation_notice: data.cancellationnotice,
      documenttypename: data.documenttypename,
      documenttypecode: data.documenttypecode,
      filename: data.filename,
      documentlink: data.documentlink,
      personal_adv_injury: data.PersonalAdvInjury,
      general_aggregate: data.GeneralAggregate,
      excess_liability: data.ExcessLiability,
      excess_liability_aggregate: data.ExcessLiabilityAggregate,
      wc_el_each_accident: data.WorkCompELEachAccident,
      wc_el_disease_each_employee: data.WorkCompELDiseaseEachEmployee,
      wc_el_disease_policy_limit: data.WorkCompELDiseasePolicyLimit,
      created_by: this.loginId
    };

    return this.httpClient.post(this.url + '/par/insurance', body).catch(this.userFriendlyMsgs.errorHandler);
  }

  // update new par info
  updateparIns(data, type?) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    this.loginId = localStorage.getItem('loginID');
    const body = {
      policynum: data.policynum,
      phonenum: data.phonenum,
      contact: data.contact,
      insurancevendor: data.insurancevendor,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      postalcode: data.postalcode,
      expiration: data.expiration,
      general_liability_occurance: data.generalliabilityoccurance,
      // workmas_comp_liability_limit: data.workmascompliabilitylimit,
      eo_cyber: data.eo_cyber,
      crimefidelity: data.crimefidelity,
      auto_liability_limit: data.autoliabilitylimit,
      auto_liability_expiration: data.autoexpiration,
      garage_liability_limit: data.garageliabilitylimit,
      // cancellation_notice: data.cancellationnotice,
      documenttypename: data.documenttypename,
      documenttypecode: data.documenttypecode,
      filename: data.filename,
      documentlink: data.documentlink,
      personal_adv_injury: data.PersonalAdvInjury,
      general_aggregate: data.GeneralAggregate,
      excess_liability: data.ExcessLiability,
      excess_liability_aggregate: data.ExcessLiabilityAggregate,
      wc_el_each_accident: data.WorkCompELEachAccident,
      wc_el_disease_each_employee: data.WorkCompELDiseaseEachEmployee,
      wc_el_disease_policy_limit: data.WorkCompELDiseasePolicyLimit,
      updated_by: this.loginId
    }
    return this.httpClient.put(this.url + '/par/insurance/document/' + data.docid, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  deleteAgentInsurance(data) {
    // this.headers = new Headers({
    //   'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    // return this.http.delete(this.url + '/parinsurance/deleteinsurancedoc?docid=' + data._id, this.options)
    return this.httpClient.delete(this.url + '/par/insurance/document/' + data._id).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par_insurance/par-insurance.service.ts